import { Group } from '@mui/icons-material'
import { Typography } from '@mui/material'
import Grid from '@mui/material/Unstable_Grid2/Grid2'
import PessoaSelecionada from '../PessoaSelecionada/PessoaSelecionada'
import { VisitantesContext } from '../../../../Providers/VisitantesContext/VisitantesContext'
import { useContext } from 'react'
import OneButton from '../../../../Components/OneButton/OneButton'

const PessoasSelecionadas = () => {
    const { moradoresSelecionados, setTabIndex, setLiberarMoradorButton, liberarMorador } = useContext(VisitantesContext)

    return (
        <Grid sx={{
            display: 'flex',
            flexDirection: 'column',
            width: '20%',
            height: '100%',
            padding: '3px',
            flexWrap: 'nowrap',
            overflowY: 'scroll',
            alignItems: 'center'
            // border: '1px solid blue'
        }}>
            <Grid sx={{
                display: 'flex',
                flexDirection: 'row',
                width: '100%',
                height: '10%',
                alignItems: 'center',
                justifyContent: 'center'
            }}>
                <Group sx={{ ...TypographySx, fontSize: '15px' }}/>
                <Typography sx={{ ...TypographySx, marginLeft: '5px' }}>
                    Pessoas Selecionadas:
                </Typography>
            </Grid>
            <Grid sx={{
                display: 'flex',
                flexDirection: 'column',
                width: '100%',
                height: '80%',
                alignItems: 'center',
                justifyContent: 'flex-start',
                // flexWrap: 'wrap',
                overflowY: 'scroll'
            }}>
                {moradoresSelecionados && moradoresSelecionados.length > 0
                    ? (
                        moradoresSelecionados.map((pessoa, index) => {
                            return <PessoaSelecionada pessoa={pessoa} key={index} />
                        })
                    )
                    : (
                        <div>
                            <Typography sx={{ ...TypographySx, fontSize: '13px' }}>
                    Nenhuma pessoa selecionada!
                            </Typography>
                        </div>
                    )
                }
            </Grid>
            { moradoresSelecionados && moradoresSelecionados.length > 0 &&
            <OneButton
                id="button-liberar-morador"
                color="one_primary"
                variant="contained"
                backgroundColor= { liberarMorador ? '#b81414' : "#FFA500" }
                newSx={{ fontSize: '12px', marginBottom: '5px' }}
                onClick={() => setLiberarMoradorButton(!liberarMorador)}
            >
                { liberarMorador ? 'Desfazer' : 'Liberar Moradores'}
            </OneButton> }
            {!liberarMorador &&
                <Grid>
                    <OneButton
                        id="button"
                        color="one_primary"
                        backgroundColor="#0FBB00"
                        variant="contained"
                        onClick={() => {
                            setTabIndex(1)
                        }}
                        newSx={{
                            fontSize: '12px'
                        }}
                    >
                    Cadastrar Visitante
                    </OneButton>
                </Grid>
            }
        </Grid>
    )
}

export default PessoasSelecionadas

const TypographySx = {
    color: 'black',
    fontWeight: 700,
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '13px'
}
